exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-transparent-backdrop ~ .modal-backdrop {\n    background: #0000001f;\n}\nfooter.modal-footer {\n    border-bottom-right-radius: 0.2rem;\n    border-bottom-left-radius: 0.2rem;\n    background: #eaeaea;\n}\n", ""]);

// exports
